module.exports = __webpack_public_path__ + "img/kmlookbook3web.95c65224.jpg";